<template>
    <div>
        <div class="col-12 lg:col-12 px-0">
            <Toolbar class="mb-2">
                <template #end>
                <Button
                    label="Nuevo"
                    icon="pi pi-plus"
                    class="p-button-success mr-2"
                    @click="agregarEntrada"
                />                
                </template>
            </Toolbar>
        </div>

        <DataTable            
            :value="lstEntradas"
            dataKey="Id_producto_entrada"
            ref="dt"
            v-model:filters="filters" 
            :globalFilterFields="['Producto.Producto',
                                'Producto.Marca',
                                'Producto.Modelo']"           
            :loading="loading"
            :paginator="true"
            :rows="10"
            scrollable
            responsiveLayout="scroll"
            scrollDirection="both"
            scrollHeight="550px"
        >
            <template #header>                
                <div class="table-header">
                <h5>Salidas</h5>
                <span
                    >Número de entradas {{ lstEntradas ? lstEntradas.length : 0 }}</span
                >
                <span class="p-input-icon-left">
                    <i class="pi pi-search" />
                    <InputText type="text" v-model="filters['global'].value"  placeholder="Buscar..."/>
                </span>
                </div>
            </template>
            <template #empty> No se encontrarón registros. </template>
            <template #loading> Cargando datos. Espere por favor. </template>                   
            <Column style="width: 9rem" field="Fecha" header="Fecha" sortable >            
                <template #body="slotProps">
                    {{getFechaWCF(slotProps.data.Fecha,false)}}
                </template>
            </Column>
            <Column style="width: 30rem" field="Producto.Producto" header="Producto" sortable >
                <template #body="{data}">
                    {{ data.Producto.Producto }} <span v-if="data.Producto.PENAEC"><br><b>PNAEC:</b> {{ data.Producto.Numero_penaec }}</span> <span v-if="data.Producto.Programa_mantenimiento"><br><b>Programa mantenimiento:</b> {{ data.Producto.Programa_mantenimiento_anio }}</span>
                </template>
            </Column>            
            <Column style="width: 20rem" field="Producto.Marca" header="Marca" sortable ></Column>
            <Column style="width: 20rem" field="Producto.Modelo" header="Modelo" sortable ></Column>   
            <Column
                field="Producto.Url_imagen"
                header="IMAGEN"
                :sortable="false"
                style="min-width: 12rem"
            >
                <template #body="slotProps">
                <Image :src="concatenarImagen(slotProps.data.Producto.Url_imagen)" alt="Image" :width="slotProps.data.Producto.Url_imagen==''?'50':'100'" />
                </template>
            </Column>         
            <Column style="width: 10rem" field="Cantidad" header="Cantidad" sortable ></Column>            
        </DataTable>

        <Dialog 
        :style="{ width: '750px' }"
        :visible="showNewEntrada"
        :modal="true"   
        :closable="false">
            <template #header>
                <h3>Entrada de productos</h3>
            </template>   
            <div class="grid">
                <div class="col-12">
                    <label>Producto</label>
                    <Dropdown class="w-full"
                            v-model="objEntrada.Producto_seleccionado"
                            :options="lstProductos"
                            optionLabel="Producto"
                            placeholder="Selecciona una producto"
                            :showClear="true"
                            :filter="true"
                            :filterFields="['Producto','Marca','Modelo']"
                            >
                        <template #value="slotProps">
                            <div v-if="slotProps.value">                                                                                        
                                <span style="font-weight:bold">{{slotProps.value.Producto}} -</span>
                                {{slotProps.value.Marca}} - {{slotProps.value.Modelo}}
                                <span v-if="slotProps.value.PENAEC">, PNAEC {{ slotProps.value.Numero_penaec }}</span> <span v-if="slotProps.value.Programa_mantenimiento">, Programa mantenimiento {{ slotProps.value.Programa_mantenimiento_anio }}</span>
                            </div>
                            <span v-else>
                                {{slotProps.placeholder}}
                            </span>
                        </template>
                        <template #option="slotProps">
                            <div v-if="slotProps.option">                               
                                <span style="font-weight:bold">{{slotProps.option.Producto}} -</span>
                                {{slotProps.option.Marca}} - {{slotProps.option.Modelo}}   
                                <span v-if="slotProps.option.PENAEC">, PNAEC {{ slotProps.option.Numero_penaec }}</span> <span v-if="slotProps.option.Programa_mantenimiento">, Programa mantenimiento {{ slotProps.option.Programa_mantenimiento_anio }}</span>

                            </div>
                        </template>      
                    </Dropdown>
                </div>              
            
                <div class="col-6">
                    <label for="cantidad">Cantidad</label>
                    <InputNumber class="w-full" id="cantidad" v-model="objEntrada.Cantidad" :useGrouping="false" />
                </div>              
                <div class="col-6">
                    <label for="fecha">Fecha</label>
                    <Calendar class="w-full" id="fecha" v-model="objEntrada.Fecha_entrada" />
                </div>   

                <div class="col-12">
                    <label>Observaciones</label>
                    <Textarea class="w-full" v-model="objEntrada.Observacion" rows="5"   />
                </div>

                <div class="col-12">
                    <InlineMessage v-show="mensajes" >{{ mensajes }}</InlineMessage >
                </div>
            </div>
            <template #footer>                
                <Button label="Cancelar" icon="pi pi-times" class="p-button-text" @click="cerrarDialogo()"/>                
                <Button label="Aceptar" icon="pi pi-check" class="p-button-text" @click="guardarEntrada()"/>                
            </template>
        </Dialog>
    </div>
</template>

<script>
import {FilterMatchMode} from 'primevue/api';
import Utilerias from '../utilidades/Utilerias'
import {mapGetters} from 'vuex';
import SvrProductos from "../service/Productos";

export default {
    data(){
        return{
            objEntrada:{ Observacion:"" },
            lstProductos:[],
            showNewEntrada:false,
            loading:false,
            lstEntradas: [],
            mensajes:"",
            filters: {'global': {value: null, matchMode: FilterMatchMode.CONTAINS}},
        }
    },
    mounted() {
        var t = this;
        t.cargaEntradas();
    },
    methods:{
        concatenarImagen(urlImagen){
            if(urlImagen != "")
                return this.getUrlServicios + urlImagen.replace("~/","");
            else
                return "../assets/sinImagen.png";
        },
        guardarEntrada(){
            var t = this;
            t.mensajes = "";
            if(!t.objEntrada || !t.objEntrada.Producto_seleccionado || !t.objEntrada.Cantidad || t.objEntrada.Cantidad<=0 || !t.objEntrada.Fecha_entrada)
            {
                t.mensajes = "Debe seleccionar un producto, especificar la cantidad y la fecha de entrada.";
                return;
            }

            t.objEntrada.Fecha = t.formateaFechaDATE(t.objEntrada.Fecha_entrada);
            t.objEntrada.Id_producto = t.objEntrada.Producto_seleccionado.Id_producto;
            t.objEntrada.Id_usuario = t.getUsuarioLogueado.Usuario.Id_usuario;

            var clsServer = new SvrProductos();
            clsServer.addEntradaProducto(t,t.objEntrada).then(res =>{
                if(res){
                    t.cargaEntradas();
                    t.cerrarDialogo();
                }
            });

            
        },
        cerrarDialogo(){
            this.objEntrada = {  Observacion:"" };
            this.lstProductos = [];
            this.showNewEntrada = false;
            this.mensajes ="";
        },
        agregarEntrada(){
            this.showNewEntrada = true;
            this.cargaProductos();
        },
        cargaEntradas(){
            var t = this;
            var clsProds = new SvrProductos();
            clsProds.getAllEntradasProductos(t).then(res=>{
                
                t.lstEntradas = res;
            });
        },
        cargaProductos(){
            var t = this;
            var clsProds = new SvrProductos();
            clsProds.getInsumos(t).then(res=>{
                
                t.lstProductos = res.filter(p=>p.Activo);
            });
        },
        getFechaWCF(fecha,hora){
            var utils = new Utilerias();
            return utils.getFechaWCF(fecha,hora);
        },
        formateaFechaDATE(fecha){
            var utils = new Utilerias();
            return utils.formateaFechaDATE(fecha);
        }
    },
    computed:{
        ...mapGetters(['getUrlServicios','getUsuarioLogueado','getUrlReportes']),  
    },  
}
</script>

<style scoped>
.table-header {
  display: flex;
  justify-content: space-between;
  -webkit-box-pack: justify;
}
.title {
  font-weight: 700;
  letter-spacing: 0.3px;
  margin-right: 10px;
  text-transform: uppercase;
}
.data {
  letter-spacing: 0.3px;
  margin-right: 10px;
  letter-spacing: 0.5px;
}
.product-image {
  width: 100px;  
  /* box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23); */
}
</style>